"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConnection = createConnection;
exports.createKitRpc = createKitRpc;
var web3_js_1 = require("@solana/web3.js");
var wallet_adapter_base_1 = require("@solana/wallet-adapter-base");
var kit_1 = require("@solana/kit");
// Network endpoints mapping
var NETWORK_ENDPOINTS = (_a = {},
    _a[wallet_adapter_base_1.WalletAdapterNetwork.Mainnet] = 'https://api.mainnet-beta.solana.com',
    _a[wallet_adapter_base_1.WalletAdapterNetwork.Testnet] = 'https://api.testnet.solana.com',
    _a[wallet_adapter_base_1.WalletAdapterNetwork.Devnet] = 'https://api.devnet.solana.com',
    _a);
// Default connection config
var DEFAULT_CONNECTION_CONFIG = {
    commitment: 'confirmed',
    confirmTransactionInitialTimeout: 60000, // 1 minute
};
/**
 * Creates a new Solana connection for the specified network or RPC URL
 * @param networkOrUrl The Solana network or RPC URL to connect to
 * @param commitmentOrConfig Optional commitment level or connection configuration
 * @returns A Connection instance
 */
function createConnection(networkOrUrl, commitmentOrConfig) {
    var endpoint;
    // Determine if the input is a network enum or direct URL
    if (Object.values(wallet_adapter_base_1.WalletAdapterNetwork).includes(networkOrUrl)) {
        // It's a network enum
        endpoint = NETWORK_ENDPOINTS[networkOrUrl];
    }
    else {
        // It's a direct URL
        endpoint = networkOrUrl;
    }
    // Prepare the connection config
    var connectionConfig;
    if (!commitmentOrConfig) {
        // Use default config if none provided
        connectionConfig = DEFAULT_CONNECTION_CONFIG;
    }
    else if (typeof commitmentOrConfig === 'string') {
        // If only commitment is provided
        connectionConfig = __assign(__assign({}, DEFAULT_CONNECTION_CONFIG), { commitment: commitmentOrConfig });
    }
    else {
        // If full config is provided
        connectionConfig = __assign(__assign({}, DEFAULT_CONNECTION_CONFIG), commitmentOrConfig);
    }
    // Create and return the connection
    return new web3_js_1.Connection(endpoint, connectionConfig);
}
/**
 * Creates a new Kit Rpc connection for the specified network or RPC URL
 * @param networkOrUrl The Solana network or RPC URL to connect to
 * @returns A Kit Rpc instance
 */
function createKitRpc(networkOrUrl) {
    var endpoint;
    // Determine if the input is a network enum or direct URL
    if (Object.values(wallet_adapter_base_1.WalletAdapterNetwork).includes(networkOrUrl)) {
        // It's a network enum
        endpoint = NETWORK_ENDPOINTS[networkOrUrl];
    }
    else {
        // It's a direct URL
        endpoint = networkOrUrl;
    }
    // Create and return the Kit Rpc
    return (0, kit_1.createSolanaRpc)(endpoint);
}
// Export connection helper utilities
__exportStar(require("./helpers"), exports);
